import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import './App.css';
import '@coreui/coreui/dist/css/coreui.min.css';

import Header           from './components/Header';
import Sidebar          from './components/Sidebar';
import Dashboard        from './pages/Dashboard';
import HomePage         from './pages/HomePage';
import Login            from './pages/Login';
import SettingsPage     from './pages/SettingsPage';
import DowntimeForm     from './pages/DowntimeForm';
import DowntimeViewer   from './pages/DowntimeViewer';
import DataSummary      from './pages/DataSummary';
import Summary          from './pages/Summary';
import LoginHistoryPage from './pages/LoginHistoryPage';
import apiService       from './services/apiService';

function App() {
  const [sidebarOpen,     setSidebarOpen]     = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading,       setIsLoading]       = useState(true);

  // ✅ User info in React state (memory only) — not in sessionStorage
  // Invisible in DevTools Application tab
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const userData = await apiService.verifyToken();

      if (userData && userData.valid) {
        // ✅ Store in React state — never touches sessionStorage
        setCurrentUser({
          employeeCode: userData.employeeCode,
          employeeName: userData.employeeName,
          location:     userData.location,
          department:   userData.department,
        });
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        setCurrentUser(null);
      }

      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    if (userData?.employeeCode) {
      // ✅ Store in React state only — nothing goes to sessionStorage
      setCurrentUser({
        employeeCode: userData.employeeCode,
        employeeName: userData.employeeName,
        location:     userData.locationName || '',
        department:   userData.departmentName || '',
      });
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  const handleLogout = async () => {
    await apiService.logout();

    // ✅ Clear React state
    setCurrentUser(null);
    setIsAuthenticated(false);

    // ✅ Only clear UI state from sessionStorage — no sensitive data
    sessionStorage.removeItem('dashboardParams');
    sessionStorage.removeItem('homePageSelections');

    // Clean up any old keys from previous versions
    sessionStorage.clear();
    localStorage.removeItem('Token');
    localStorage.removeItem('email');
    localStorage.removeItem('UserCode');
    localStorage.removeItem('PlantCode');
    localStorage.removeItem('UserName');
    localStorage.removeItem('userEmail');
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f2f5' }}>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <div style={{ fontSize: '18px', color: '#333', marginBottom: '10px' }}>Loading...</div>
          <div style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #3498db', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
        </div>
      </div>
    );
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        {isAuthenticated ? (
          <div className="app-layout">
            <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
            <div className={`main-area ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
              {/* ✅ Pass currentUser to Header for display */}
              <Header
                toggleSidebar={toggleSidebar}
                sidebarOpen={sidebarOpen}
                onLogout={handleLogout}
                currentUser={currentUser}
              />
              <main className="main-content">
              <Routes>
                <Route path="/"                         element={<Navigate to="/home" replace />} />
                <Route path="/home"                     element={<HomePage />} />
                <Route path="/dashboard"                element={<Dashboard />} />
                <Route path="/summary" element={<Summary currentUser={currentUser} />} />
                <Route path="/settings"                 element={<SettingsPage />} />
                {/* ✅ Pass currentUser to DataSummary if it needs employee info */}
                <Route path="/settings/data-summary"    element={<DataSummary currentUser={currentUser} />} />
                <Route path="/settings/downtime-form"   element={<DowntimeForm />} />
                <Route path="/settings/downtime-viewer" element={<DowntimeViewer />} />
                <Route path="/settings/login-history"   element={<LoginHistoryPage />} />
                <Route path="/login"                    element={<Navigate to="/home" replace />} />
                <Route path="*"                         element={<Navigate to="/home" replace />} />
              </Routes>
              </main>
            </div>
          </div>
        ) : (
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="*"      element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;






// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// // Import CSS files FIRST
// import './App.css';
// import '@coreui/coreui/dist/css/coreui.min.css';

// // Then import components
// import Header from './components/Header';
// import Sidebar from './components/Sidebar';
// import Dashboard from './pages/Dashboard';
// import HomePage from './pages/HomePage';
// import Login from './pages/Login';
// import SettingsPage from './pages/SettingsPage';
// import DowntimeForm from './pages/DowntimeForm';
// import DowntimeViewer from './pages/DowntimeViewer';
// import DataSummary from './pages/DataSummary';
// import Summary from './pages/Summary';
// import LoginHistoryPage from './pages/LoginHistoryPage';

// // ProtectedRoute component
// const ProtectedRoute = ({ children }) => {
//   const token = sessionStorage.getItem('Token'); // ✅ changed to sessionStorage
//   return token ? children : <Navigate to="/login" replace />;
// };

// function App() {
//   const [sidebarOpen, setSidebarOpen] = useState(true);

//   // ✅ Use sessionStorage — clears automatically when tab/window is closed
//   const [isAuthenticated, setIsAuthenticated] = useState(() => {
//     const token = sessionStorage.getItem('Token');
//     console.log('Initial auth check - Token exists:', !!token);
//     return !!token;
//   });

//   const [isLoading, setIsLoading] = useState(true);

//   // Check authentication status on app load
//   useEffect(() => {
//     const checkAuth = () => {
//       const token = sessionStorage.getItem('Token'); // ✅ changed to sessionStorage
//       console.log('useEffect auth check - Token:', token);
//       console.log('useEffect auth check - Token exists:', !!token);
//       setIsAuthenticated(!!token);
//       setIsLoading(false);
//     };

//     checkAuth();

//     // Listen for storage changes (useful for logout from another tab)
//     window.addEventListener('storage', checkAuth);

//     return () => {
//       window.removeEventListener('storage', checkAuth);
//     };
//   }, []);

//   // Function to handle successful login
//     const handleLogin = (userData) => {
//       if (userData && userData.employeeCode) {
//         const authToken = userData.employeeCode;

//         sessionStorage.setItem('Token', authToken);
//         sessionStorage.setItem('email', userData.workEmail || userData.email || '');
//         sessionStorage.setItem('UserCode', userData.employeeCode);
//         sessionStorage.setItem('PlantCode', userData.locationName || '');
//         sessionStorage.setItem('UserName', userData.employeeName?.split(' ')[0] || userData.employeeCode);
//         sessionStorage.setItem('userEmail', userData.employeeCode);

//         setIsAuthenticated(true);
//         return true;  // ✅ Signal success to Login.js
//       }

//       return false;   // ✅ Signal failure to Login.js
//     };

//   // Function to handle logout
//   const handleLogout = () => {
//     console.log('Logging out...');

//     // ✅ All changed to sessionStorage
//     sessionStorage.removeItem('Token');
//     sessionStorage.removeItem('email');
//     sessionStorage.removeItem('UserCode');
//     sessionStorage.removeItem('PlantCode');
//     sessionStorage.removeItem('UserName');
//     sessionStorage.removeItem('userEmail');

//     // Clear old localStorage keys too (cleanup for existing users)
//     localStorage.removeItem('Token');
//     localStorage.removeItem('email');
//     localStorage.removeItem('UserCode');
//     localStorage.removeItem('PlantCode');
//     localStorage.removeItem('UserName');
//     localStorage.removeItem('userEmail');

//     sessionStorage.removeItem('dashboardParams');

//     setIsAuthenticated(false);
//   };

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Show loading screen while checking authentication
//   if (isLoading) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         backgroundColor: '#f0f2f5'
//       }}>
//         <div style={{
//           textAlign: 'center',
//           padding: '20px'
//         }}>
//           <div style={{
//             fontSize: '18px',
//             color: '#333',
//             marginBottom: '10px'
//           }}>
//             Loading...
//           </div>
//           <div style={{
//             width: '40px',
//             height: '40px',
//             border: '4px solid #f3f3f3',
//             borderTop: '4px solid #3498db',
//             borderRadius: '50%',
//             animation: 'spin 1s linear infinite',
//             margin: '0 auto'
//           }}></div>
//         </div>
//       </div>
//     );
//   }

//   console.log('Rendering - isAuthenticated:', isAuthenticated);

//   return (
//     <Router basename={process.env.PUBLIC_URL}>
//       <div className="App">
//         {isAuthenticated ? (
//           // Authenticated: show full app
//           <div className="app-layout">
//             <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
//             <div className={`main-area ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
//               <Header
//                 toggleSidebar={toggleSidebar}
//                 sidebarOpen={sidebarOpen}
//                 onLogout={handleLogout}
//               />
//               <main className="main-content">
//                 <Routes>
//                   <Route path="/" element={<Navigate to="/home" replace />} />
//                   <Route path="/home" element={<HomePage />} />
//                   <Route path="/dashboard" element={<Dashboard />} />
//                   <Route path="/summary" element={<Summary />} />
//                   <Route path="/settings" element={<SettingsPage />} />
//                   <Route path="/settings/data-summary" element={<DataSummary />} />
//                   <Route path="/settings/downtime-form" element={<DowntimeForm />} />
//                   <Route path="/settings/downtime-viewer" element={<DowntimeViewer />} />
//                   <Route path="/settings/login-history" element={<LoginHistoryPage />} />
//                   <Route path="/login" element={<Navigate to="/home" replace />} />
//                   <Route path="*" element={<Navigate to="/home" replace />} />
//                 </Routes>
//               </main>
//             </div>
//           </div>
//         ) : (
//           // Not authenticated: show only login
//           <Routes>
//             <Route path="/login" element={<Login onLogin={handleLogin} />} />
//             <Route path="*" element={<Navigate to="/login" replace />} />
//           </Routes>
//         )}
//       </div>
//     </Router>
//   );
// }

// export default App;
